import React from 'react';
import { getDetailSeekData } from '../../../../../../api';
import SeekButton from './SeekButton/SeekButton';
import { PATH } from '../../../../../../constants';
import { TEXT } from '../../../../../../content';
import './SeekList.css';

const SeekList = props => {
  const { detailId, onVideoSeek } = props;
  const seekLinks = getDetailSeekData(detailId).map(linkData => (
    <SeekButton key={linkData.time} data={linkData} onVideoSeek={onVideoSeek} />
  ));

  return (
    <React.Fragment>
      {seekLinks.length > 0 && (
        <div id="seek-list">
          <img
            id="seek-title"
            src={`${PATH.IMG}title/tvare.png`}
            alt={TEXT.FACES}
          />
          <div>{seekLinks}</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SeekList;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/SeekList/SeekList.js